import { render, staticRenderFns } from "./QuizMain.vue?vue&type=template&id=35663a66&scoped=true&"
import script from "./QuizMain.vue?vue&type=script&lang=js&"
export * from "./QuizMain.vue?vue&type=script&lang=js&"
import style0 from "./QuizMain.vue?vue&type=style&index=0&id=35663a66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35663a66",
  null
  
)

export default component.exports